import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IPatient, IPatientDataSourceBackendParam } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { PatientService } from "src/app/providers/patient.service";

export class LastActivityListDataSource extends MatTableDataSourceBackendExtended<IPatient> {
  constructor(private patientService: PatientService) {
    super();
  }

  public data(params: IPatientDataSourceBackendParam): Observable<IPatient[]> {
    return this.patientService.listLastActivityInfos(params);
  }

  protected dataCount(params: IPatientDataSourceBackendParam): Observable<number> {
    return this.patientService.countLastActivityInfos(params);
  }
}
